import { render, staticRenderFns } from "./IconInfo3.vue?vue&type=template&id=59049071&scoped=true&"
import script from "./IconInfo3.vue?vue&type=script&lang=js&"
export * from "./IconInfo3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59049071",
  null
  
)

export default component.exports